import { Action } from "redux";

import { APIFailureAction, APIRequestAction, APISuccessAction } from "@/mk2/helpers/action";

export interface ForumSearchApiAction extends Action {
    readonly query: string;
}

export const FORUM_SEARCH_API_REQUEST = "FORUM_SEARCH_API_REQUEST";

export interface ForumSearchApiRequestAction extends ForumSearchApiAction, APIRequestAction {
    readonly type: typeof FORUM_SEARCH_API_REQUEST;
}

export const FORUM_SEARCH_API_SUCCESS = "FORUM_SEARCH_API_SUCCESS";

export interface ForumSearchApiSuccessAction extends ForumSearchApiAction, APISuccessAction {
    readonly type: typeof FORUM_SEARCH_API_SUCCESS;
}

export const FORUM_SEARCH_API_FAILURE = "FORUM_SEARCH_API_FAILURE";

export interface ForumSearchApiFailureAction extends ForumSearchApiAction, APIFailureAction {
    readonly type: typeof FORUM_SEARCH_API_FAILURE;
}

export const forumSearchApi = {
    request: (query: string): ForumSearchApiRequestAction => ({
        type: FORUM_SEARCH_API_REQUEST,
        query,
    }),
    success: (query: string, response: any): ForumSearchApiSuccessAction => ({
        type: FORUM_SEARCH_API_SUCCESS,
        query,
        response,
    }),
    failure: (query: string, error: any): ForumSearchApiFailureAction => ({
        type: FORUM_SEARCH_API_FAILURE,
        query,
        error,
    }),
};

export const FORUM_SEARCH_SAVE = "FORUM_SEARCH_SAVE";

export interface ForumSearchSaveAction extends ForumSearchApiAction {
    readonly type: typeof FORUM_SEARCH_SAVE;
}

export const forumSearchSave = (query: string): ForumSearchSaveAction => ({
    type: FORUM_SEARCH_SAVE,
    query,
});

export const FORUM_SEARCH = "FORUM_SEARCH";

export interface ForumSearchAction extends ForumSearchApiAction {
    readonly type: typeof FORUM_SEARCH;
}

export const forumSearch = (query: string): ForumSearchAction => ({ type: FORUM_SEARCH, query });

/** Used for state updates */
export const FORUM_SEARCH_UPDATE = "FORUM_SEARCH_UPDATE";

export interface ForumSearchUpdateAction extends ForumSearchApiAction {
    readonly type: typeof FORUM_SEARCH_UPDATE;
}

export const forumSearchUpdate = (query: string): ForumSearchUpdateAction => ({
    type: FORUM_SEARCH_UPDATE,
    query,
});
